const initTooltip = () => {
  const { $ } = window;
  $('[data-toggle="tooltip"]').tooltip();
};

// eslint-disable-next-line import/prefer-default-export
export { initTooltip };
